import request from '@/utils/request'

// 获取登陆微信token
export function getLoginToken(data) {
  return request({
    url: '/general/wechat/open/getLoginToken',
    method: 'post',
    data
  })
}
// 获取h5分享微信token
export function getShareToken(params) {
  return request({
    url: '/general/wechat/open/getShareToken',
    method: 'get',
    params
  })
}
